import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1fc44661: FaireBrandEntity = {
  token: "b_1fc44661",
  type: "brand",
  name: "Gumball Poodle",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/19f3f05c4fce4ad4aed4be11e96f28975a59e5b0c5e4aa1a4de12a9a8692fceb/1555104747.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/84c49522d491217d5f6fdc3acc9c31714fec6ba234a557e2aed46dafdcdde0e5.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/19f3f05c4fce4ad4aed4be11e96f28975a59e5b0c5e4aa1a4de12a9a8692fceb/1555104747.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84c49522d491217d5f6fdc3acc9c31714fec6ba234a557e2aed46dafdcdde0e5.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 383,
  isTopShop: true,
  isInsider: true,
  description:
    "The Original Statement Socks\n\nMade in the USA\n\nGumball Poodle makes the perfect “OMG this is so them” gifts. Bold, expressive socks for everyone — the pet parent, the hobbyist, the loud friend, the quiet weirdo, and every oddly specific personality in between.\n\nAs a small, independent, woman-owned brand based in Los Angeles, we proudly manufacture every pair in the USA with quality you can feel and a one-size-fits-most design that keeps ordering and inventory simple. Plus, all of our packaging is fully recyclable.\n\nOur socks cover humor, nostalgia, opinions, and everyday joy, with the perfect splash of COLOR! If you want products that stand out (and stand for something), you’re at the right place.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:46.537Z",
    importedBy: "entity-db-cli",
  },
};
